export const environment = {
  production: true,
  apiBaseUrl: 'https://api.filparty.com/api/v0'
};
